(function() {
  var ROOT = document.querySelector('[data-apex-bundle]');
  if (!ROOT) return;
  var ID = ROOT.getAttribute('data-apex-bundle');

  /* ── Versandvorteil: echte Bedingung der Shopify-Versandprofile ──
     TOTAL_PRICE >= 100 EUR. NICHT die Stueckzahl. Stand 08.09.2026. */
  var THRESHOLD = 10000;                /* in Cent */
  var PRICE = parseInt(ROOT.getAttribute('data-apex-price') || '0', 10);   /* in Cent */

  function fmt(cents, en) {
    var v = (cents / 100).toFixed(2);
    return en ? '€' + v : v.replace('.', ',') + ' €';
  }

  var MONEY_TEXTS = {
    DE: { nFree:'Noch {m} bis zum Gratis-Versand', nRed:'Noch {m} bis zum reduzierten Versand', uFree:'Gratis-Versand freigeschaltet ✓', uRed:'Reduzierter Versand freigeschaltet ✓', en:false },
    FR: { nFree:'Encore {m} pour la livraison gratuite', nRed:'Encore {m} pour la livraison réduite', uFree:'Livraison gratuite débloquée ✓', uRed:'Livraison réduite débloquée ✓', en:false },
    ES: { nFree:'Faltan {m} para el envío gratuito', nRed:'Faltan {m} para el envío reducido', uFree:'Envío gratuito desbloqueado ✓', uRed:'Envío reducido desbloqueado ✓', en:false },
    IT: { nFree:'Ancora {m} per la spedizione gratuita', nRed:'Ancora {m} per la spedizione ridotta', uFree:'Spedizione gratuita sbloccata ✓', uRed:'Spedizione ridotta sbloccata ✓', en:false },
    NL: { nFree:'Nog {m} voor gratis verzending', nRed:'Nog {m} voor verlaagde verzending', uFree:'Gratis verzending ontgrendeld ✓', uRed:'Verlaagde verzending ontgrendeld ✓', en:false },
    GB: { nFree:'{m} to go for free shipping', nRed:'{m} to go for reduced shipping', uFree:'Free shipping unlocked ✓', uRed:'Reduced shipping unlocked ✓', en:true },
    PL: { nFree:'Jeszcze {m} do darmowej wysyłki', nRed:'Jeszcze {m} do obniżonej wysyłki', uFree:'Darmowa wysyłka odblokowana ✓', uRed:'Obniżona wysyłka odblokowana ✓', en:false }
  };

  function moneyTextsFor(c) {
    if (c === 'AT' || c === 'CH') return MONEY_TEXTS.DE;
    return MONEY_TEXTS[c] || MONEY_TEXTS.DE;
  }

  /*
    Versandsätze exakt wie in den Shopify-Versandprofilen (Stand 02.09.2026).
    std   = Standardversand
    three = Satz ab 100 EUR Bestellwert; 0 = kostenlos; null = kein verguenstigter Tarif
  */
  var RATES = {
    DE: { std: '5,99',  three: '0'    },
    AT: { std: '8,99',  three: '2,99' },

    BE: { std: '9,50',  three: '2,99' },
    CZ: { std: '9,50',  three: '2,99' },
    DK: { std: '9,50',  three: '2,99' },
    FR: { std: '9,50',  three: '2,99' },
    LU: { std: '9,50',  three: '2,99' },
    NL: { std: '9,50',  three: '2,99' },
    PL: { std: '9,50',  three: '2,99' },

    AD: { std: '9,99',  three: '2,99' },
    ES: { std: '9,99',  three: '2,99' },
    HU: { std: '9,99',  three: '2,99' },
    IT: { std: '9,99',  three: '2,99' },
    PT: { std: '9,99',  three: '2,99' },
    SE: { std: '9,99',  three: '2,99' },
    SI: { std: '9,99',  three: '2,99' },
    SK: { std: '9,99',  three: '2,99' },
    SM: { std: '9,99',  three: '2,99' },
    VA: { std: '9,99',  three: '2,99' },

    CY: { std: '12,95', three: '3,95' },
    EE: { std: '12,95', three: '3,95' },
    FI: { std: '12,95', three: '3,95' },
    GR: { std: '12,95', three: '3,95' },
    HR: { std: '12,95', three: '3,95' },
    IE: { std: '12,95', three: '3,95' },
    LT: { std: '12,95', three: '3,95' },
    LV: { std: '12,95', three: '3,95' },
    MT: { std: '12,95', three: '3,95' },

    CH: { std: '11,00', three: null },
    GB: { std: '11,00', three: null },
    LI: { std: '11,00', three: null },

    AL: { std: '16,50', three: null },
    BA: { std: '16,50', three: null },
    IS: { std: '16,50', three: null },
    ME: { std: '16,50', three: null },
    NO: { std: '16,50', three: null },
    RS: { std: '16,50', three: null }
  };

  var DACH = [
    { flag: '🇩🇪', code: 'DE' },
    { flag: '🇦🇹', code: 'AT' },
    { flag: '🇨🇭', code: 'CH' }
  ];

  var FLAGS = {
    FR:'🇫🇷',NL:'🇳🇱',PL:'🇵🇱',CZ:'🇨🇿',DK:'🇩🇰',SE:'🇸🇪',HU:'🇭🇺',
    PT:'🇵🇹',IT:'🇮🇹',ES:'🇪🇸',GR:'🇬🇷',FI:'🇫🇮',EE:'🇪🇪',LV:'🇱🇻',
    LT:'🇱🇹',HR:'🇭🇷',SK:'🇸🇰',SI:'🇸🇮',MT:'🇲🇹',IE:'🇮🇪',NO:'🇳🇴',
    RS:'🇷🇸',AL:'🇦🇱',BA:'🇧🇦',IS:'🇮🇸',GB:'🇬🇧',LU:'🇱🇺',BE:'🇧🇪',
    LI:'🇱🇮',AD:'🇦🇩',SM:'🇸🇲',VA:'🇻🇦',CY:'🇨🇾',ME:'🇲🇪',
    DE:'🇩🇪',AT:'🇦🇹',CH:'🇨🇭'
  };

  var TEXTS = {
    DE: { single:'Einzelpreis', triple:'Produkte kaufen', free:'Gratis-Versand', freeBadge:'Versand geschenkt', shipOnly:'Versand nur {p} €', shipBadge:'Versand nur {p} €', popular:'Am beliebtesten', shipping:'Versand' },
    FR: { single:'Prix unitaire', triple:'produits à acheter', free:'Livraison gratuite', freeBadge:'Livraison offerte', shipOnly:'Livraison {p} € seulement', shipBadge:'Livraison {p} €', popular:'Le plus populaire', shipping:'Livraison' },
    ES: { single:'Precio unitario', triple:'productos a comprar', free:'Envío gratuito', freeBadge:'Envío gratis', shipOnly:'Envío solo {p} €', shipBadge:'Envío {p} €', popular:'El más popular', shipping:'Envío' },
    IT: { single:'Prezzo unitario', triple:'prodotti da acquistare', free:'Spedizione gratuita', freeBadge:'Spedizione gratis', shipOnly:'Spedizione solo {p} €', shipBadge:'Spedizione {p} €', popular:'Il più popolare', shipping:'Spedizione' },
    NL: { single:'Stukprijs', triple:'producten kopen', free:'Gratis verzending', freeBadge:'Verzending gratis', shipOnly:'Verzending slechts {p} €', shipBadge:'Verzending {p} €', popular:'Meest populair', shipping:'Verzending' },
    GB: { single:'Unit price', triple:'products to buy', free:'Free shipping', freeBadge:'Shipping on us', shipOnly:'Shipping only €{p}', shipBadge:'Shipping €{p}', popular:'Most popular', shipping:'Shipping' },
    PL: { single:'Cena jednostkowa', triple:'produkty do kupienia', free:'Darmowa wysyłka', freeBadge:'Wysyłka gratis', shipOnly:'Wysyłka tylko {p} €', shipBadge:'Wysyłka {p} €', popular:'Najpopularniejszy', shipping:'Wysyłka' }
  };

  /* ── IP-basierte Ländererkennung ── */
  var country = 'DE';

  /* Texte folgen der Seitensprache (/fr, /it ...), die Versandpreise
     dem Land. Vorher kamen auch die Texte vom Land (28.09.2026). */
  var LANGMAP = { de:'DE', fr:'FR', es:'ES', it:'IT', nl:'NL', en:'GB', pl:'PL' };
  var LANGKEY = LANGMAP[(document.documentElement.lang || 'de').slice(0, 2).toLowerCase()] || 'DE';
  function pageTexts() { return TEXTS[LANGKEY] || TEXTS.DE; }

  function textsFor(c) {
    if (c === 'AT' || c === 'CH') return TEXTS.DE;
    return TEXTS[c] || TEXTS.DE;
  }

  function init(c) {
    country = (c || 'DE').toUpperCase();
    var t = pageTexts();
    renderLabels(t);
    renderShipping(country, t);
    applyState(0, t);
    pollCart();
  }

  /* Land: zuerst Shopifys eigene Erkennung, ipapi.co nur als Notnagel. */
  if (window.Shopify && window.Shopify.country) {
    init(window.Shopify.country);
  } else fetch('https://ipapi.co/json/')
    .then(function(r){ return r.json(); })
    .then(function(d){ init(d.country_code); })
    .catch(function(){
      var urlMatch = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/i);
      var langMap = { de:'DE',fr:'FR',nl:'NL',pl:'PL',cs:'CZ',da:'DK',sv:'SE',hu:'HU',pt:'PT',it:'IT',es:'ES',el:'GR',fi:'FI',et:'EE',lv:'LV',lt:'LT',hr:'HR',sk:'SK',sl:'SI',mt:'MT',ga:'IE',nb:'NO',sr:'RS',sq:'AL',bs:'BA',is:'IS',en:'GB' };
      var c = urlMatch ? (langMap[urlMatch[1].toLowerCase()] || 'DE') : 'DE';
      init(c);
    });

  function renderShipping(c, t) {
    var el = document.getElementById('apex-ship-' + ID);
    if (!el) return;

    var chips = [];
    if (c === 'DE' || c === 'AT' || c === 'CH') {
      DACH.forEach(function(d){
        chips.push({ flag: d.flag, price: RATES[d.code].std });
      });
    } else if (RATES[c]) {
      chips.push({ flag: FLAGS[c] || '', price: RATES[c].std });
    }

    /* Land ohne hinterlegte Versandzone: lieber nichts behaupten. */
    if (chips.length === 0) { el.innerHTML = ''; return; }

    var html = '<div class="apex-ship-row"><span class="apex-ship-label">' + t.shipping + '</span>';
    chips.forEach(function(d){
      html += '<div class="apex-ship-chip"><span>' + d.flag + '</span><span>' + d.price + ' €</span></div>';
    });
    html += '</div>'
    el.innerHTML = html;
  }

  function renderLabels(t) {
    var sl = document.getElementById('apex-single-label-' + ID);
    var tl = document.getElementById('apex-triple-label-' + ID);
    var fl = document.getElementById('apex-free-label-' + ID);
    var bl = document.getElementById('apex-badge-' + ID);
    var sv = document.getElementById('apex-savings-' + ID);

    if (sl) sl.textContent = t.single;
    if (tl) tl.textContent = t.triple;
    if (bl) bl.textContent = t.popular;

    var rate = RATES[country];
    var three = rate ? rate.three : null;

    /* Der 3er-Kauf schaltet den Vorteil nur frei, wenn 3 Stueck die
       100-EUR-Schwelle wirklich erreichen. Sonst keine Behauptung. */
    var tripleQualifies = (PRICE * 3) >= THRESHOLD;

    if (fl) {
      if (!tripleQualifies || three === null || three === undefined) fl.textContent = '';
      else if (three === '0') fl.textContent = t.free;
      else fl.textContent = t.shipOnly.replace('{p}', three);
    }

    if (sv) {
      if (!tripleQualifies || three === null || three === undefined) sv.textContent = '';
      else if (three === '0') sv.textContent = t.freeBadge;
      else sv.textContent = t.shipBadge.replace('{p}', three);
    }
  }

  function applyState(totalCents, t) {
    var single = document.getElementById('apex-single-' + ID);
    var triple = document.getElementById('apex-triple-' + ID);
    var progress = document.getElementById('apex-progress-' + ID);
    var progressText = document.getElementById('apex-progress-text-' + ID);
    var progressFill = document.getElementById('apex-progress-fill-' + ID);
    if (!single) return;

    var rate = RATES[country];
    var three = rate ? rate.three : null;
    var isFree = three === '0';
    var mt = MONEY_TEXTS[LANGKEY] || MONEY_TEXTS.DE;

    /* Ohne verguenstigten Tarif gibt es nichts freizuschalten -> Balken weg. */
    if (progress) progress.hidden = (three === null || three === undefined);

    var missing = THRESHOLD - totalCents;
    var pct = Math.min((totalCents / THRESHOLD) * 100, 100);
    if (progressFill) progressFill.style.width = pct + '%';

    if (progressText) {
      var msg;
      if (missing > 0) {
        msg = (isFree ? mt.nFree : mt.nRed).replace('{m}', fmt(missing, mt.en));
      } else {
        msg = isFree ? mt.uFree : mt.uRed;
      }
      progressText.textContent = msg;
    }

    if (totalCents >= THRESHOLD) {
      triple.classList.add('is-active');
      single.classList.remove('is-active');
    } else {
      single.classList.add('is-active');
      triple.classList.remove('is-active');
    }
  }

  function pollCart() {
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){
        applyState(cart.total_price, pageTexts());
      })
      .catch(function(){});
  }

  setInterval(pollCart, 2000);
  document.addEventListener('cart:updated', pollCart);
  document.addEventListener('cart-update', pollCart);
})();
